<template>
  <div
    class="bas-dropdown"
    :class="{ collapsed: collapsed }"
  >
    <div class="label" v-if="label">
      <span>
        {{ label }}
      </span>
    </div>
    <div class="dropdown-container">
      <div
        class="header"
        @click="onDropDownClick"
      >
        <div
          class="selection-overlay"
          v-if="selection"
        >
          <span>{{ selection }}</span>
        </div>
        <div class="left">
        </div>
        <div class="right">
          <div class="arrow-down"></div>
        </div>
      </div>
      <div
        class="options-container"
        v-if="collapsed"
      >
        <div
          class="option"
          v-for="(option, index) in options"
          v-on:click="handleSelection(option.label ? option.label : option)"
          :key="index"
        >
          {{ option.label ? option.label : option }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },
    dropDownId: {
      type: String
    },
    onItemSelect: {
      type: Function,
      required: true
    },
    onOpen: {
      type: Function,
      required: true
    },
    enabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      collapsed: false,
      selection: null
    };
  },
  methods: {
    onDropDownClick() {
      if (!this.enabled || this.selection) return;
      this.collapsed = !this.collapsed;
      if (this.collapsed) {
        this.onOpen(this.dropDownId, this.collapsed);
      }
    },

    handleSelection(option) {
      this.onItemSelect({
        dropDownId: this.dropDownId,
        option
      });

      this.selection = option;
      this.collapsed = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.bas-dropdown {
  position: relative;
  z-index: 500;
  width: 100%;
  opacity: 0;

  &.collapsed {
    z-index: 510;
  }

  .label {
    font-family: 'hwtfutura-bold';
    font-size: 20px;
    text-align: left;
    margin-bottom: 5px;
  }

  .dropdown-container {
    position: relative;
    width: 100%;
    border: none;
    background-color: white;
    padding: 0 0 0 0;

    .header {
      position: relative;
      height: 40px;
      border: 2px solid black;
      z-index: 1;
      cursor: pointer;

      .selection-overlay {
        position: absolute;
        padding-left: 10px;
        // compensate parent border
        top: -3px;
        left: -3px;
        width: 100%;
        // add border to fit parent and be able to use percentage
        border: 3px solid yellow;
        background-color: yellow;
        color: blue;
        font-size: 20px;
        font-family: 'hwtfutura-bold';
        text-align: left;
        line-height: 40px;
        cursor: default;
      }

      .left, .right {
        display: inline-block;
      }

      .left {
        font-size: 20px;
        font-family: 'hwtfutura-bold';
      }

      .right {
        float: right;
        border-left: 1px solid black;
        width: 35px;
        height: 100%;
      }

      .arrow-down {
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 10px solid black;
        margin-top: 13px;
        margin-left: 11px;
      }

      .right {
        float: right;
      }
    }

    .options-container {
      position: absolute;
      top: 44px;
      left: 0;
      z-index: 2;
      width: 100%;
      background-color: yellow;

      .option {
        font-family: hwtfutura;
        font-size: 20px;
        text-align: left;
        padding: 5px 10px 5px 10px;
        color: blue;
        transition: 0.5s;
        cursor: pointer;

        &:hover {
          background-color: blue;
          color: yellow;
        }
      }
    }
  }
}
</style>
